import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCard.css';
import { PagingTable,MessageBox } from 'component-lib';
import { RoleConfiguration } from 'utils-lib';
import { DocumentsModel, RequestAjaxClass} from 'models-lib';

class CustomerDocumentData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerData";
        this.state.DocumentList=[];
        this.CustomerId = props.id;
        this.state.Upload=false;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.DocumentsModel = new DocumentsModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler((data)=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setAuth(true);
        this.Request2.setErrorHandler((data)=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });
    }

    Update(observer)
    {
        this.setState({},()=>{
          if(observer === "Documents"){
            let me =this;
            if (me.refs.table){
              me.refs.table.setState({ Data: this.DocumentsModel.Documents, Count: this.DocumentsModel.Count, Limit: this.DocumentsModel.Limit, Start: this.DocumentsModel.Start, End: this.DocumentsModel.Start + this.DocumentsModel.Documents.length });
            }
            me.setState({ Count:this.DocumentsModel.Count });
            $("#LoadingIcon").removeClass().addClass('hide');
          } 
          else if(observer === "FileParams"){
            let me =this;
            let max = me.DocumentsModel.MaxNumber;
            let number = me.state.Count;
            if (max > 0){
              if (number >= max){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Message={Vas.Resources.Labels["LimitDocuments"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    , document.getElementById('messageContainer'));
              } else {
                localStorage.setItem('DocumentSchoolUpload',false);
                Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
              }
            } else {
              localStorage.setItem('DocumentSchoolUpload',false);
              Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
            }
          }
          else if(observer === "DeleteDocument"){
            let me = this;
            $("#LoadingIcon").removeClass().addClass('hide');
            if(this.DocumentsModel.DeleteSuccess === true){
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.Labels["DocumentDeleteSuccess"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));    
              me.load(me.refs.table.PrepareSendData());
            }else{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            }
          }  
        });
    }

    load(sendData){
      this.Request.setErrorHandler((data)=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });
      this.DocumentsModel.SetRequest(this.Request);
      this.DocumentsModel.GetDocumentsByCustomerId(this.CustomerId,sendData);
    }

    Upload(){
        let me = this;
        this.Request2.setErrorHandler((data)=>{
          if (me.state.Count >= 5){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["LimitDocuments"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          } else {
            localStorage.setItem('DocumentSchoolUpload',false);
            Vas.GetView("CustomerDocumentUpload",{CustomerId : me.CustomerId},true);
          }
        });
        this.DocumentsModel.SetRequest(this.Request2);
        this.DocumentsModel.GetFileParamsByCustomerId(this.CustomerId);
    }

    Delete(e){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      let id = $(e.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;

      this.DocumentsModel.SetRequest(this.Request);
      this.DocumentsModel.DeleteDocumentByDocumentId(id);
    }

    render()
    {
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        let right = '';
        if (role === "1"){
            if (rights[1]){
                right =  rights[1];
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
                right = rights[0];
            }
        }

        let upload='';
        if (this.state.Upload ===  true){
            upload=(<div 
              className={"paymentDetails"} 
              id={"uploadDocument"} >
            </div>);
        } else {
            upload=<td><div></div></td>;
        }

        return (
          <div >
            <table style={{ width: '600px' }} >
              <tbody>
                <tr>
                  <td>
                    <PagingTable 
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table" 
                      TableReference={this} 
                      DataBaseTable={"Dokumente"} 
                      Selectable={false} 
                      Limit={this.state.Limit} 
                      Start={this.state.Start} 
                      End={this.state.End} 
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["DocumentName"],Vas.Resources.Labels["Size"],Vas.Resources.Labels["Action"]]}
                      Keys={["FileName","FileSize"]} 
                      Data={this.state.Data} 
                      Download={true} 
                      DownloadType={"Document"} 
                      Modus={"DBBus"}
                      Add={true} 
                      AddClick={()=>{this.Upload();}}
                      Border={false}
                      Right={right}
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      CWidth={[150,80,50]}
                      AddString={Vas.Resources.Labels["Add"]} 
                      Delete={true}
                      DeleteOnClick={(e)=>{this.Delete(e);}}
                      />
                  </td>
                        
                </tr>
                <tr>
                  {upload} 
                </tr>
              </tbody>
              <tfoot>
                    
              </tfoot>
            </table>
          </div>
        );
    }
}
export default CustomerDocumentData;
